import React from 'react';
import { useTranslation } from 'react-i18next';

import { BenefitCard } from './BenefitCard';

export const PregnancyBenefits = () => {
  const { t } = useTranslation();

  return (
    <section className="index-screen__benefits">
      <h2 className="index-screen__benefits_title">{t('evieOnboarding.indexScreen.benefits.pregnancy.title')}</h2>
      <BenefitCard>
        <p className="index-screen__benefitcard_content">{t('evieOnboarding.indexScreen.benefits.pregnancy.card1')}</p>
      </BenefitCard>
      <BenefitCard>
        <p className="index-screen__benefitcard_content">{t('evieOnboarding.indexScreen.benefits.pregnancy.card2')}</p>
      </BenefitCard>
      <BenefitCard>
        <p className="index-screen__benefitcard_content">{t('evieOnboarding.indexScreen.benefits.pregnancy.card3')}</p>
      </BenefitCard>
      <BenefitCard>
        <p className="index-screen__benefitcard_content">{t('evieOnboarding.indexScreen.benefits.pregnancy.card4')}</p>
      </BenefitCard>
    </section>
  );
};
